import React from 'react';
import styled from '@emotion/styled';
import H4 from '@components/H4';
import Subtitle1 from '@components/Subtitle1';

const Container = styled.div`
  height: 90px;
  position: relative;
  padding: 15px;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
`;

const Value = styled.span`
  font-weight: bold;
  display: block;
  font-size: 30px;
`;
const Label = styled.span`
  font-size: 14px;
  text-align: right;
  display: block;
  margin-top: 40px;
`;
const IconImgWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  border-radius: 100px;
  background: #f7f7f7;
  padding: 10px;
`;

const IconImg = styled.img`
  width: -webkit-fill-available;
`;

function ValueCard({ bottomColor, style, value, label, icon }) {
  return (
    <Container
      bottomColor={bottomColor}
      style={style}>
      <Value>
        <H4>{value}</H4>
      </Value>
      <Label>
        <Subtitle1>{label}</Subtitle1>
      </Label>
      {icon && (
        <IconImgWrapper>
          <IconImg
            src={icon}
            alt="box icon"
          />
        </IconImgWrapper>
      )}
    </Container>
  );
}

export default ValueCard;
